import React from 'react';
import { Empty } from 'antd';

const EmptySelect: React.FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {Empty.PRESENTED_IMAGE_SIMPLE}
      <p>データなし</p>
    </div>
  );
};

export default EmptySelect;
